import React, { Component } from 'react'
import { observer } from 'mobx-react'
import store from '../store'
import { getData } from '../utils'
import ResultPage from '@common/ResultPage'
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const { location = {} } = this.props
    const { cashFlowId, type } = location.query
    store.initFlowId(cashFlowId, type)
    // 此处考虑loading等待页面刷新后还保留在loading页面，后续若该逻辑无用可去除
    if (type !== 'loading') {
      store.getCashFlowStatus()
    }
  }
  render() {
    const { getCashFlowStatus, flowType } = store
    const data = getData(store)
    const props = data[flowType]
    return <ResultPage {...props} loadingEnd={getCashFlowStatus} />
  }
}
